import portraitImg from '../../../image/1.png';
import './PhilosophySection.css';

const PILLARS = [
  'Diagnóstico integral',
  'Planificación digital',
  'Biomecánica y estrategia terapéutica',
  'Tecnología de alineadores',
  'Acompañamiento profesional',
];

const PhilosophySection = () => {
  return (
    <section className="philosophy section section--lg" aria-labelledby="philosophy-heading">
      <div className="container">
        <div className="philosophy__layout">
          <aside className="philosophy__visual">
            <figure className="philosophy__figure">
              <img
                src={portraitImg}
                alt="Profesional del equipo Always Aligners"
                className="philosophy__image"
                loading="lazy"
                decoding="async"
              />
            </figure>
          </aside>

          <div className="philosophy__copy">
            <h2 id="philosophy-heading" className="philosophy__title">
              Nuestra <span className="philosophy__title-accent">filosofía</span>
            </h2>

            <div className="philosophy__body">
              <p>
                Creemos que el éxito del tratamiento con alineadores no depende únicamente del
                material utilizado, sino del diagnóstico adecuado, la correcta planificación del caso y
                la aplicación de principios biomecánicos sólidos.
              </p>
              <p className="philosophy__lead">Por eso, nuestro sistema se basa en cinco pilares fundamentales:</p>
              <ul className="philosophy__list">
                {PILLARS.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p>
                Este enfoque permite abordar cada caso de manera individualizada, adaptando el
                tratamiento a las necesidades específicas de cada paciente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
